import { render, staticRenderFns } from "./LogMailComponent.vue?vue&type=template&id=cebb0976&scoped=true"
import script from "./LogMailComponent.vue?vue&type=script&lang=js"
export * from "./LogMailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebb0976",
  null
  
)

export default component.exports